import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const createProjectType = (payload) => AxiosClient.post('/project-type', payload);
const getProjectType = (params) => AxiosClient.get('/project-type', {...params});
const updateProjectType = (projectType, payload) => AxiosClient.put(`/project-type/${projectType}`, { ...payload })
const removeProjectType = (projectType) => AxiosClient.delete(`/project-type/${projectType}`)
export {
    createProjectType,
    getProjectType,
    updateProjectType,
    removeProjectType
}